export default {
    switched: {
        before: 'We have switched you to the new design.',
        after: 'to opt out and return to the previous layout — the old design will be turned off in September.',
    },
    'opted-out': {
        before: 'You are using the previous layout.',
        after: 'to opt in to the new design — it will be enforced in September.',
    },
    'click-here': 'Click here',
    dismiss: 'Hide this message',
    'switch-to-old-design': 'Switch to the old design',
    'switch-to-new-design': 'Switch to the new design',
}
